import Vue from 'vue';
import { Form, FormItem, Select, Option, Input, Message, Button } from 'element-ui';
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Button);

Vue.prototype.$message = Message;

